import React, { useState } from 'react';
import axios from 'axios';
import ReactGA from 'react-ga4';
import { ToastContainer, toast } from 'react-toastify';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import 'react-toastify/dist/ReactToastify.css';
import './CTA.css';

const CTA = () => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    company: '',
    description: '',
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handlePhoneChange = (value, country) => {
    setFormData((prev) => ({ ...prev, phone: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    // Track form submission attempt
    ReactGA.event({
      category: 'user_engagement',
      action: 'form_submit',
      label: 'early_access_form',
      value: 1
    });

    const hubspotData = {
      fields: [
        { name: 'firstname', value: formData.firstName },
        { name: 'lastname', value: formData.lastName },
        { name: 'email', value: formData.email },
        { name: 'phone', value: formData.phone },
        { name: 'company', value: formData.company },
        { name: 'message', value: formData.description }
      ],
      context: {
        pageUri: window.location.href,
        pageName: document.title,
      },
    };

    try {
      console.log('Submitting data to HubSpot:', hubspotData);
      const response = await axios.post(
        'https://api.hsforms.com/submissions/v3/integration/submit/441778572/7d73a39c-0838-4843-887a-e45d8c0c7dbd',
        hubspotData,
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );
      console.log('HubSpot response:', response.data);
      
      // Track successful submission
      ReactGA.event({
        category: 'user_engagement',
        action: 'form_submit_success',
        label: 'early_access_form',
        value: 1
      });
      
      toast.success('Thank you for your interest! We will be in touch soon.', {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });

      setFormData({
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        company: '',
        description: '',
      });
    } catch (error) {
      console.error('Submission error details:', error.response?.data || error);
      
      // Track failed submission
      ReactGA.event({
        category: 'user_engagement',
        action: 'form_submit_error',
        label: 'early_access_form',
        value: 1,
        error_message: error.response?.data?.message || 'Unknown error'
      });
      
      toast.error('There was an error submitting the form. Please try again.', {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="contact" className="cta">
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      <div className="page-container">
        <div className="cta-content">
          <div className="page-section__header cta-section-header">
            <h2>Request Access</h2>
          </div>
          <form className="contact-form" onSubmit={handleSubmit}>
            <div className="form-row">
              <div className="form-group">
                <label>First Name *</label>
                <input
                  type="text"
                  name="firstName"
                  required
                  value={formData.firstName}
                  onChange={handleChange}
                  disabled={isSubmitting}
                  placeholder="First Name"
                />
              </div>
              <div className="form-group">
                <label>Last Name *</label>
                <input
                  type="text"
                  name="lastName"
                  required
                  value={formData.lastName}
                  onChange={handleChange}
                  disabled={isSubmitting}
                  placeholder="Last Name"
                />
              </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label>Email *</label>
                <input
                  type="email"
                  name="email"
                  required
                  value={formData.email}
                  onChange={handleChange}
                  disabled={isSubmitting}
                  placeholder="Email Address"
                />
              </div>
              <div className="form-group">
                <label>Phone Number</label>
                <PhoneInput
                  country={'au'}
                  value={formData.phone}
                  onChange={handlePhoneChange}
                  disabled={isSubmitting}
                  inputProps={{
                    required: true,
                    name: 'phone'
                  }}
                  containerClass="phone-input-container"
                  inputClass="phone-input"
                  buttonClass="phone-input-button"
                  dropdownClass="phone-input-dropdown"
                  preferredCountries={['au', 'us']}
                />
              </div>
            </div>
            <div className="form-row">
              <div className="form-group full-width">
                <label>Company Name</label>
                <input
                  type="text"
                  name="company"
                  value={formData.company}
                  onChange={handleChange}
                  disabled={isSubmitting}
                  placeholder="Company Name"
                />
              </div>
            </div>
            <div className="form-group full-width">
              <div className="form-label-row">
                <label>Tell us about your needs</label>
                <span className="char-count">{formData.description.length}/300</span>
              </div>
              <textarea
                rows="6"
                name="description"
                value={formData.description}
                onChange={handleChange}
                disabled={isSubmitting}
                maxLength={300}
                placeholder="Tell us about your needs..."
              ></textarea>
            </div>
            <button
              type="submit"
              className="btn btn-solid features-cta"
              disabled={isSubmitting}
            >
              {isSubmitting ? 'Submitting...' : 'Submit'}
            </button>
            <p className="cta-privacy">
              By submitting this form you agree to our <a href="/privacy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>.
            </p>
          </form>
        </div>
      </div>
    </section>
  );
};

export default CTA;